module.exports = __webpack_public_path__ + "assets/img/video-big.ae90021a.png";